import { Modal, Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import MultiselectTreeCtrl from "app/views/dashboard/userDashboard/MultiselectTreeCtrl";
import {BiSave, BiX} from "react-icons/bi";
import {useLazyAddEditAccessGroupFacilitiesQuery} from "app/redux/Facility/facilityApi";
import { getDefaultSelectedFromOptions } from "app/views/dashboard/modal/DropDownModal";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import { useSelector  } from "react-redux";
import {useLazyAddEditFacilitiesAccessGroupQuery} from "app/redux/Facility/facilityApi";
import { toast } from "react-toastify";

export default function AccessPointIncExclPU(props) {
  const initialState = {
    loginUserName: localStorage.getItem("loginUserName") ?? "",
    loginUserPersonId: localStorage.getItem("loginUserPersonId") ?? "",
    loginUserEmail: localStorage.getItem("loginUserEmail") ?? "",
  };
  const [addEditAccessGroupFacilities] = useLazyAddEditAccessGroupFacilitiesQuery();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { open,  eventObject, handleSubmit, closeDialog } = props;
  let FacilityPropertyUnit = eventObject.OptionsPU;
  const type = eventObject.type;
  let selectedPropUnits = getDefaultSelectedFromOptions(FacilityPropertyUnit);
  const { selectedCompanyId } = useSelector((state) => state.company);
  const [addEditFacilitiesAccessGroup] = useLazyAddEditFacilitiesAccessGroupQuery();

  const updateSelectedPU = (selectedItems) => {
    selectedPropUnits = selectedItems;
 }

  const handleFormSubmit  = async () => {
    UpdatetFacilityData(selectedPropUnits);
    
  };

  const UpdatetFacilityData = async (selectedPropUnits) => {
    showLoader();
    let obj = {};
    obj["screenType"] = "Edit";
    obj["id"] = eventObject.facilityId;
    obj["companyid"] = selectedCompanyId
    obj["name"] = initialState.loginUserName;
    obj["updatedBy"] = initialState.loginUserPersonId;
    let PUList = [];
    if (Array.isArray(selectedPropUnits)){
      selectedPropUnits.forEach((item) => {
        let obj1 = {};
        obj1["ID"] = item.ID;
        obj1["Name"] = item.Name;
        PUList.push(obj1);
      })
    }
    obj["affectedPUDetailedData"] = [];
    obj["IncludeinAffectedList"] = type === "INCLPU" ? selectedPropUnits : [];
    obj["ExcludeInAffectedList"] = type === "EXCLPU" ? selectedPropUnits : [];
    obj["IsAccessGroupUpdate"] = false;
    obj["IsIncludePropertyUnitUpdate"] = type === "INCLPU" ? true : false;
    obj["IsExcludePropertyUnitUpdate"] = type === "EXCLPU" ? true : false;

     await addEditFacilitiesAccessGroup(obj).then((result) => {
        hideLoader();
        toast.success("Successfully added", { autoClose: 2000 });
        handleSubmit();
        closeDialog();
     }, error => {
      hideLoader();
    });
    //  console.log('save obj - ', obj);
  };

  
  

  return (
    <Modal show={open} onHide={closeDialog} size="">
      <Formik
        enableReinitialize={true}
        initialValues={eventObject}
        onSubmit={handleFormSubmit}
        >
            
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <>
              <Modal.Header className="bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                <h4 className="m-0 text-white">{type === "INCLPU" ? "Inkluder enheter" : "Ekskluder enheter"} </h4>
                <i className="i-Close-Window cursor-pointer text-18" onClick={closeDialog} />
              </Modal.Header>

              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                      {/* <Form.Label>Tilgangspunkter</Form.Label> */}
                      {
                        <MultiselectTreeCtrl refId={'includeExcl-propunits'}   outSelectedItem={updateSelectedPU} options={FacilityPropertyUnit}></MultiselectTreeCtrl>
                      }

                  </Form.Group>
                </Form>
              </Modal.Body>
                <Modal.Footer className={''}>
                    <Button variant="secondary" onClick={closeDialog}>
                        <BiX  size={17}></BiX>
                        Lukke
                    </Button>

                    <Button   onClick={handleFormSubmit} variant="primary"  >
                        <BiSave  size={17}></BiSave>   Lagre endringer
                    </Button>
                </Modal.Footer>
            </>
          );
        }}
      </Formik>
      {loader}
    </Modal>
  );
}




